import React from "react";
import '../css/Certificados.css';
import certificadoFun from '../img/certificado1.png';
import certificadoFron from '../img/certificado2.png';

function Certificados() {
  return (
    <div className="service component__space" id="Certificado">

      <div className="heading">
        <h1 className="heading">Certificados Trybe</h1>
        {/* <p className="heading p__color">
          There are many variations of passages of Lorem Ipsum available,
        </p>
        <p className="heading p__color">
          but the majority have suffered alteration.
        </p> */}
      </div>

      <div className="container">
        <div className="row">
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                  <line x1="2" y1="20" x2="2" y2="20"></line>
                </svg>
              </div>
              <a href="https://ibb.co/zXMdx3j">
                <img src={certificadoFun} alt='' className="certificado" />
              </a>
              <div className="service__meta">
                <h1 className="service__text">Módulo de Fundamentos</h1>
                <p className="p service__text p__color">
                  Foi aprendido os seguintes conteúdos: Unix & Bash, Git, JS básico, DOM, HTML, CSS, JSES6, HOFS e Testes Unitários.
                </p>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
              </div>
              <a href="https://ibb.co/HHG8YGg">
                <img src={certificadoFron} alt='' className="certificado" />
              </a>
              <div className="service__meta">
                <h1 className="service__text">Módulo de Front-End</h1>
                <p className="p service__text p__color">
                  Foi aprendido os seguintes conteúdos: React, Componentes Controlados, Testes com RTL, Redux com React, Context API e React Hooks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certificados;